import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ok2",
  "use": "icon-icon-ok2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-icon-ok2\"><path class=\"cls-1\" d=\"M794.9,202.2l-342.7,342.7c-17.8,17.8-46.6,17.8-64.4,0l-159-159c-25.4-25.4-66.7-25.4-92.1,0l-53.6,53.6c-25.4,25.4-25.4,66.7,0,92.1l191.2,191.2-1,1,99.7,99.7c25.4,25.4,66.7,25.4,92.1,0l475.6-475.6c25.4-25.4,25.4-66.7,0-92.1l-53.6-53.6c-25.4-25.4-66.7-25.4-92.1,0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol